export default __webpack_public_path__ + "static/media/ear.cfb864d7.svg";